module.exports = __webpack_public_path__ + "img/mockup2-bnw.0b25b854.jpg";